<template>
    <div>
        <item-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :paginationData="filterSet.page" ></item-filter-link>
        <item-list-link :listLayout="listLayout" :paginationData="filterSet.page" :itemData="List"></item-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :listLength="List.length" :type="itemType"></pagination-link>
    </div>
</template>

<script>
    import ItemFilterLink from "@/components/item/ItemFilterLink";
    import ItemListLink from "@/components/item/ItemListLink";
    import PaginationLink from "@/components/item/PaginationLink";
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import alertMixins from "@/mixins/alertMixins";
    import itemUtil from "@/components/item/itemUtil";
    import util from "@/mixins/util";
    import EventBus from "@/utils/event-bus";
    import DeleteClass from "@/mixins/deleteClass";

    const {filterConfig} = itemUtil;

    export default {
        name: "ItemListComponent",
        mixins: [filterMixins,listMixins,alertMixins,itemUtil],
        components: {ItemFilterLink,ItemListLink,PaginationLink},
        provide() {
            return {
                setPage: this.setPage,
                setFilter: this.setFilter,
                itemListSetData: this.setData,
                itemListDelete: this.runDeleteConfirm,
            }
        },
        inject: ['changeLoading'],
        props: {
            itemType: {default: ''},
            defaultLang: {default: null,}
        },
        data() {
            return {
                listLayout: '',
                filterLayout: '',
                paginationLayout: '',

                getCategoryFunc: '',
                categoryApiParamsSet: {},
                getFunc: '',
                listApiParamSet: {},
                pageRow: 10,

                deleteFunc: '',
                deleteApiParamsSet: {},
                deleteSuccessType: 1,
                deleteFailTypes: {},
                keyName: 'i_idx',
                /*필터 classname*/


                selectArr: [],
                deleteIndex: 0,
                DeleteClass: null,
            }
        },
        created() {
            this.setFilterConfig(filterConfig)
            this.setParserType('url', this.$route.fullPath);
            this.initConfig();
        },
        mounted() {
            // this.getCategory();
            this.getList(true);
            EventBus.$on('itemListInitConfig', this.initConfig);
        },
        beforeDestroy() {
            EventBus.$off('itemListInitConfig');
        },
        destroyed() {},
        computed: {
        },
        methods: {
            setData(type, value) {
                this[type] = value;
            },
            initConfig() {
                let config = this.returnItemConfig(this.itemType)
                this.listLayout= config.listLayout;
                this.filterLayout = config.filterLayout;
                this.paginationLayout = config.paginationLayout;
                this.getCategoryFunc = config.getCategoryFunc;
                this.categoryApiParamsSet = config.categoryApiParamsSet;
                this.getFunc = config.getFunc;
                this.listApiParamSet = config.listApiParamSet;

                this.deleteFunc = config.deleteFunc;
                this.deleteApiParamsSet = config.deleteApiParamsSet;
                this.deleteSuccessType = config.deleteSuccessType;
                this.deleteFailTypes = config.deleteFailTypes;

                this.keyName = config.keyName;

                let listOptions = {
                    url : this.$api.$item[this.getFunc],
                    defaultParams : this.listApiParamSet
                }
                //this.setFilter('cid', this.defaultLang)
                this.initList('api', listOptions);
                this.newDeleteClass();
            },
            getCategory() {
                if(util.isEmpty(this.getCategoryFunc)) {
                    return false;
                }
                let params = Object.assign({}, this.categoryApiParamsSet);
                if(!util.isEmpty(this.defaultLang)) {
                    params.cid = this.defaultLang;
                }
                try {
                    this.$api.$item[this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type === 1) {
                            this.Categories = res.List;
                        }
                    })
                }catch (e) {
                    console.log(e);
                }
            },
            getList(isFirst=false) {
                let filterSet = JSON.parse(JSON.stringify(this.getFilterSet()));
                if(isFirst) {
                    let parsingDataPage = this.getPasingDataPage();
                    filterSet.page.page = parsingDataPage;
                    this.List = [];
                }else if(this.isInitPage === true) {
                    /*this.filterSet.page.page = 1;
                    this.setPage('page', 1);*/
                    filterSet.page.page = 1;
                }
                if(this.listClass === null) {
                    return false;
                }
                this.listClass.getList(this.filterSet).then(res => {
                    let list = res.list.slice();

                    if(this.paginationType === 'lazyload' && this.List.length > 0 && this.hasPre) {
                        this.List = list.concat(this.List.slice());
                    }else if(this.paginationType === 'lazyload' && this.List.length > 0) {
                        this.List = this.List.concat(list.slice());
                    }else{
                        this.List = list.slice();
                    }
                    if(res.hasOwnProperty('total')) {
                        this.setPage('total', res.total);
                    }
                    if(filterSet.page.page != this.filterSet.page.page && this.isInitPage === true) {
                        this.setPage('page', filterSet.page.page);
                    }
                    if(isFirst) {
                        this.setParsingDataPageFilterSet();
                    }
                    this.isInitPage = false;
                })
            },

            newDeleteClass() {
                let deleteOptions = {
                    func: this.$api.$item[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            },
            runDeleteConfirm() {
                if (this.selectArr.length === 0) {
                    this.errorAlert('목록을 선택해주세요.');
                    return false;
                }
                this.createConfirm({
                    content: '정말 삭제하시겠습니까?',
                    confirm: () => {
                        // this.deleteIndex = 0;
                        // this.deleteLastIndex = this.selectArr.length - 1;
                        this.runDelete();
                    }
                })
            },
            runDelete() {
                this.changeLoading(true);
                this.DeleteClass.runDelete(this.selectArr);
            },
            deleteAfterFunc() {
                if (this.deleteIndex < this.deleteLastIndex) {
                    this.deleteIndex = this.deleteIndex + 1;
                    this.runDelete()
                } else {
                    this.changeLoading(false);
                    this.createAlert({
                        content: '삭제되었습니다.',
                        hide: () => {
                            this.deleteIndex = 0;
                            this.getList();
                        }
                    })
                }
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
